import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=1b10c275&scoped=true"
import script from "./RecycleBin.vue?vue&type=script&lang=js"
export * from "./RecycleBin.vue?vue&type=script&lang=js"
import style0 from "./RecycleBin.vue?vue&type=style&index=0&id=1b10c275&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10c275",
  null
  
)

export default component.exports